import { InjectionToken } from '@angular/core';

export const SOFTLINE_FEATURE_MESSAGE_BAR = 'messageBar';
export const SOFTLINE_CONFIG_MESSAGE_BAR_DURATION = new InjectionToken<number>(
  'SOFTLINE_CONFIG_MESSAGE_BAR_DURATION'
);
